import React,{ useCallback, useEffect, useState, useContext } from "react";
import { Divider, Progress, Steps } from "antd";
import { DenominationTypes } from "../../constants/DenominationTypes";
import OrderInformationHeader from "./OrderInformationHeader";
import OrderInformationRow from "./OrderInformationRow";
import { calculateOrderRowAmount, calculateTotalAmounts, getRateAllRows, getTotalDeliveryFee, getTotalOrderFee, voidBNOrder } from "./OrderService";
import OrderInformationFooter from "./OrderInformationFooter";
import AlertBox from "../shared/AlertBox";
import LoadingBox from "../shared/LoadingBox";
import Icon, { BankOutlined, CheckOutlined, DollarOutlined, RocketTwoTone }  from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruck } from "@fortawesome/free-solid-svg-icons";
import { formatToCurrencyWithScale } from "../../helpers/FormatHelper";
import { useMemo } from "react";
import { useRef } from "react";
import { useLayoutEffect } from "react";
import { getNextBusinessDate } from "../../networking/NetworkingHolidays";
import { ConfirmExit } from "./ConfirmExit";
import OrderSpreadModalForm from "./OrderSpreadModalForm";
import { OrderContext } from "./OrderScreen";

export function OrderInformationScreen({customerName, customerID, buyCcy, crossR, objOrder, updateOrder, lockedSide, currenciesList, settlementCurrenciesList, deliveryMethodList,changeScreen, updateBuyCurrencyValue,vaults,refreshRates, resetRefreshRates
      , editCostRate, backToSearchScreen, showCostRate, editCustomerRate, instruments, settlementMethods, defaultInstrument, defaultSettlementMethod, defaultSettlementCurrency, updateExistsRows, originalDeliveryMethod, originalTotalOrder, allowOrderCurrentDate,newOrder,contactID, customerType, customerDefaultDeliveryMethod}) {

    const { rateStore, setBuyScaleCtx} = useContext(OrderContext);

    const [buyCurrency, setBuyCurrency] = useState(buyCcy);
    const baseCurrency = localStorage.getItem('BNBase Currency');
    const [crossRate, setCrossRate] = useState(0);
    const [buyScale, setBuyScale] = useState(2);
    const today = new Date();
    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const [deliveryDate, setDeliveryDate] = useState(today);
    const [deliveryTime, setDeliveryTime] = useState(`${hours}:${minutes}`);
    const [deliveryCustomerID, setDeliveryCustomerID] = useState(0);
    const [deliveryText, setDeliveryText] = useState('');
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [orderFee, setOrderFee] = useState(0);
    const [deliveryContactName, setDeliveryContactName] = useState('');
    const [totalBuyAmount, setTotalBuyAmount] = useState(0);
    const [totalDenominationFees, setTotalDenominationFees] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showVoidConfirmation, setShowVoidConfirmation] = useState(false);
    const [showDuplicateCcyConfirmation, setShowDuplicateCcyConfirmation] = useState(false);
    const [duplicateCcyMessage, setDuplicateCcyMessage] = useState('');
    const [newRow, setNewRow] = useState({CurrencyID:''});
    const [instrument, setInstrument] = useState('');
    const [settlementMethod, setSettlementMethod] = useState('');
    const [vaultID, setVaultID] = useState(0);
    const [showNewOrderConfirmation, setShowNewOrderConfirmation] = useState(false);
    //const [nextBusinessDate, setNextBusinessDate] = useState(today);
    const { Step } = Steps;
    const INITIAL_TIME = localStorage.getItem('BN Rate Timeout'); 


  const [seconds, setSeconds] = useState(INITIAL_TIME);
  const [isRunning, setIsRunning] = useState(false);

    const [orderRows, setOrderRows] = useState([{
        key:1,
        CurrencyID: '',
        CurrencyName:'',
        CurrencyScale: 2,
        Denominations: [],
        Amount: 0,
        Rate: 0,
        BuyAmount: 0,
        Fee:0,
        DenominationType: DenominationTypes.notes,
        Profit:0,
        CostRate: 0,
        RatePrecision:8,
        MixedDenominations:false,
        ShowInverseRate: false,
        AllowDenominationFees: false,
        NoteConditions: 'Regular',
        AutorefreshRate:true,
        AverageRate: 0,
        OriginalCustomerRate: 0,
        OriginalCostRate: 0,
        validations:{
            CurrencyID: true,
            Denominations: true,
            Amount: true,
            Rate: true,
            BuyAmount: true,
            NoteConditions: true
        }        
    }]);
   
    const orderRowsRef = useRef(orderRows); //for timer

    const [validationsHeader, setValidationsHeader] = useState(
      {
          DeliveryCustomerID: true,
          DeliveryDate: true,
          DeliveryTime: true,
          DeliveryMethod: true,
          BuyCurrency: true,
          CrossRate: true,
          Instrument: true,
          SettlementMethod: true,
          VaultID:true
        }
      )

    const getNextDay = () =>{
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      let validNextDate = false;

      if(allowOrderCurrentDate)
      {
        startDate.setDate(startDate.getDate() - 1);
      }

      while(!validNextDate)
      {
        startDate.setDate(startDate.getDate() + 1);

        if(startDate.getDay() !== 0 && startDate.getDay()!== 6)
        {
          validNextDate = true;
        }
     }
      return new Date(startDate);
    }

    useEffect(()=>{

      if(orderRows.length > 0)
      {
        updateExistsRows(orderRows[0].CurrencyID !== '')

        const anyRefresh = (orderRows && orderRows.length > 0) ? orderRows.some(o =>
            o.AutorefreshRate || o.AutorefreshRate === undefined
        ) : true;
        
        if (!anyRefresh) {
            stopTimer();
            setSeconds(INITIAL_TIME);
        }
      }
      else
      {
        updateExistsRows(false);
      }

    },[orderRows, updateExistsRows])

     useEffect(()=>{
        
        const nextDay = getNextDay();
        const hours = '14';//String(today.getHours()).padStart(2, '0');
        const minutes = '00';//String(today.getMinutes()).padStart(2, '0');
      
        setDeliveryDate(nextDay);
        setDeliveryTime(`${hours}:${minutes}`);
      },[])

      useEffect(()=>{  
        setBuyCurrency(buyCcy);
        setCrossRate(crossR);
      },[buyCcy, crossR])
  
    useEffect(()=> {
      if(objOrder && objOrder.OrderRows && objOrder.OrderRows.length>0)
      {
        setOrderRows(objOrder.OrderRows);     
      }
      if(objOrder.BuyCurrency)
      {
        setBuyCurrency(objOrder.BuyCurrency);
      }
      if(objOrder.SettlementInstrument)
      {
        setInstrument(objOrder.SettlementInstrument);
      }
      if(objOrder.SettlementMethod)
      {
        setSettlementMethod(objOrder.SettlementMethod);
      }
      if(objOrder.CrossRate)
      {
        setCrossRate(objOrder.CrossRate);
      }
      if(objOrder.DeliveryDate && objOrder.DeliveryDate !== '' && objOrder.DeliveryTime && objOrder.DeliveryTime !== '')
      {
        setDeliveryDate(objOrder.DeliveryDate);
        setDeliveryTime(objOrder.DeliveryTime);
      }
      if(objOrder.DeliveryMethod && objOrder.DeliveryMethod !== '')      {
        setDeliveryMethod(objOrder.DeliveryMethod);

        const showVaultAdd = (lockedSide.toLowerCase() === 'buy' && objOrder.DeliveryMethod.toLowerCase().includes('armored'));

        if(objOrder.DeliveryCustomerID > 0)
        {
          setDeliveryCustomerID(objOrder.DeliveryCustomerID);      
          setDeliveryText(objOrder.DeliveryText);
          setDeliveryFee(objOrder.DeliveryFee);
          setDeliveryContactName(objOrder.DeliveryContactName); 
        }   
        
        if(objOrder.VaultID > 0 && showVaultAdd)
        {
          setVaultID(objOrder.VaultID);      
          setDeliveryText(objOrder.VaultAddress);
        }
      }
    },[objOrder])

    /*useEffect(() => {

    if (!objOrder) return;

      if (
        !initializedRef.current &&
        objOrder.OrderRows &&
        objOrder.OrderRows.length > 0
      ) {

        setOrderRows(
          objOrder.OrderRows.map(r => ({
            ...r,
            Denominations: r.Denominations ? [...r.Denominations] : []
          }))
        );

        initializedRef.current = true;
      }

      if (objOrder.BuyCurrency) {
        setBuyCurrency(objOrder.BuyCurrency);
      }

      if (objOrder.SettlementInstrument) {
        setInstrument(objOrder.SettlementInstrument);
      }

      if (objOrder.SettlementMethod) {
        setSettlementMethod(objOrder.SettlementMethod);
      }

      if (objOrder.CrossRate) {
        setCrossRate(objOrder.CrossRate);
      }

      if (
        objOrder.DeliveryDate &&
        objOrder.DeliveryDate !== '' &&
        objOrder.DeliveryTime &&
        objOrder.DeliveryTime !== ''
      ) {
        setDeliveryDate(objOrder.DeliveryDate);
        setDeliveryTime(objOrder.DeliveryTime);
      }

      if (objOrder.DeliveryMethod && objOrder.DeliveryMethod !== '') {

        setDeliveryMethod(objOrder.DeliveryMethod);

        const showVaultAdd =
          lockedSide.toLowerCase() === 'buy' &&
          objOrder.DeliveryMethod.toLowerCase().includes('armored');

        if (objOrder.DeliveryCustomerID > 0) {
          setDeliveryCustomerID(objOrder.DeliveryCustomerID);
          setDeliveryText(objOrder.DeliveryText);
          setDeliveryFee(objOrder.DeliveryFee);
          setDeliveryContactName(objOrder.DeliveryContactName);
        }

        if (objOrder.VaultID > 0 && showVaultAdd) {
          setVaultID(objOrder.VaultID);
          setDeliveryText(objOrder.VaultAddress);
        }
      }

    }, [objOrder, lockedSide]);
*/
    useEffect(()=>{
        const calculateTotals = async() =>{
        const totals = calculateTotalAmounts(orderRows);
        
            if(totals)
            {
                let orderFee = (objOrder)?objOrder.OrderFee?? 0:0;
                let deliveryFeeRes = (objOrder) ? objOrder.DeliveryFee?? 0 :0;
                if(totals.BuyAmount !== objOrder.TotalOrder && totals.BuyAmount > 0)
                {
                    const responseTotalOrderFee = await getTotalOrderFee(customerID, totals.BuyAmount/*totalBuyAmount*/, lockedSide, buyCurrency);
                    orderFee = (responseTotalOrderFee.Success)?responseTotalOrderFee.TotalOrderFee:0;
                }
                
                if ((objOrder.TotalOrder !== totals.BuyAmount && totals.BuyAmount > 0) || (objOrder.DeliveryMethod !== deliveryMethod && deliveryMethod !== '' && totals.BuyAmount > 0))
                {
                    let deliveryFeeId = 0;
                    const fee = deliveryMethodList.find(f => f.name === deliveryMethod)
                    if(fee && fee.DeliveryFeeID > 0) { deliveryFeeId = fee.DeliveryFeeID; }
                    const responseDeliveryFee = await getTotalDeliveryFee(customerID, totals.BuyAmount/*totalBuyAmount*/, lockedSide, deliveryFeeId, buyCurrency);
                    deliveryFeeRes = (responseDeliveryFee.Success)?responseDeliveryFee.TotalDeliveryFee:deliveryFee;
                }


                setTotalBuyAmount(totals.BuyAmount);
                setTotalDenominationFees(totals.DenominationFee);
                setTotalProfit(totals.Profit);
                setOrderFee(orderFee);
                setDeliveryFee(deliveryFeeRes);
            }
        }
        calculateTotals();
    },[orderRows, deliveryMethod]);

  /*  useEffect(() => {
      if (!timerIsRunning) {
        if(isRunning){
          setIsRunning(false)
          setSeconds('')
        }
      }
      else
      {
        if(seconds !== '')
        {
          setIsRunning(true);
        }
      }
      
    }, [timerIsRunning]);*/
    
    /*useEffect(()=>{
      if(deliveryDate !== undefined){        
        let newDate = new Date(deliveryDate);
        let releaseDate = `${newDate.getFullYear()}/${
              String(newDate.getMonth() + 1).padStart(2, '0')
            }/${
              String(newDate.getDate()).padStart(2, '0')
            }`;

        getNextBusinessDate(releaseDate,0).then(
          (json) => {            
            if(json !== undefined && json.nextDate !== undefined){
              if(new Date().getHours() > 16) { setNextBusinessDate(new Date(json.nextDate).setDate(new Date(json.nextDate).getDate() + 1)) }
              else { setNextBusinessDate(new Date(json.nextDate).setDate(new Date(json.nextDate).getDate())) }
            }
          }
        )
      }
    },[deliveryDate])*/

    const getRows=()=>{
        const rows = [];
        if(orderRows)
        {
            orderRows.forEach((o, index) =>{
              rows.push(<OrderInformationRow key={o.key} customerID={customerID} rowObject={o} rowID={o.key} lockedSide={lockedSide} buyCurrency={buyCurrency} currenciesList={currenciesList}
                buyScale={buyScale} onDeleteRow={onDeleteRow} onUpdateFieldRow={onUpdateFieldRow} validations={o.validations} onUpdateRowAmounts={onUpdateRowAmounts} onUpdateRowDenominations={onUpdateRowDenominations}
                deliveryDate={deliveryDate} autoFocus={(orderRows.length > 1 && index === orderRows.length - 1 && (o.CurrencyID === undefined || o.CurrencyID === ''))} openAlert={openAlert} editCostRate={editCostRate} showCostRate={showCostRate} editCustomerRate={editCustomerRate} />)
            })
        }
        return rows;
    }

    const currencyAlreadyExists = (currencyID, noteConditions, key) => {
      if(newRow && newRow.CurrencyID === 'Valid')
        return true;

      const existCCy = orderRows.find(o => o.CurrencyID === currencyID && o.NoteConditions === noteConditions && o.key !== key);
      if(existCCy)
        return false
      return true;
    }

    const rowIsValid = (lastOrder) =>{
      
      const prev = lastOrder.validations;
      const demoninationsAmount = calculateOrderRowAmount(lastOrder.Denominations, lastOrder.DenominationType);

      const validations = {
        ...prev,
        Amount: lastOrder.Amount > 0,
        BuyAmount: lastOrder.BuyAmount > 0,
        CurrencyID: !!lastOrder.CurrencyID && currencyAlreadyExists(lastOrder.CurrencyID, lastOrder.NoteConditions, lastOrder.key),
        Denominations: lastOrder.MixedDenominations || Number(lastOrder.Amount) === demoninationsAmount,
        Rate: lastOrder.Rate > 0,
        NoteConditions: lastOrder.NoteConditions !== ''
      };

      return validations;
    }

    const onAddClick =() =>{
        const order = {};
        order.key = orderRows.length > 0 ? (orderRows[orderRows.length - 1].key + 1) : 1;
        order.BuyAmount = 0;
        order.Fee = 0;
        order.NoteConditions = 'Regular';
        order.DenominationType = DenominationTypes.notes;
        order.Denominations = [];
        order.ShowInverseRate = false;
        order.AllowDenominationFees = false;
        order.AutorefreshRate = true;
        order.OriginalCustomerRate= 0;
        order.OriginalCostRate=  0;
        
        order.validations={
            CurrencyID: true,
            Denominations: true,
            Amount: true,
            Rate: true,
            BuyAmount: true,
            NoteConditions: true
        }        

        const orders = [...orderRows];
        if(orders.length > 0)
        {
          const lastOrder = orders[orders.length - 1];
          const validations = rowIsValid(lastOrder)
          orders[orders.length - 1] = {...lastOrder,validations};
          setNewRow({CurrencyID:''});
            
          if(Object.values(validations).every(Boolean))
          {
            order.validations = validations;
            orders.push(order);
          }   
          else
          {
          const duplicateCcy = orders.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
            if(duplicateCcy)
            {
              order.validations = validations;
              setNewRow(order);
              setDuplicateCcyMessage(`The Order has duplicate Currencies. Do you want to continue?`);       
              setShowDuplicateCcyConfirmation(true);
            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
          }               
        }
        else
        {
          orders.push(order);
        }
        setOrderRows(orders);
    }

    const onDeleteRow = (key) => {
        let rows = [...orderRows];    
        rows = rows.filter((d) => d.key !== key);
        setOrderRows(rows);
    };
    
    const onUpdateFieldRow = (key, Field, value) =>{

      const anyRefresh = (orderRows && orderRows.length > 0) ? orderRows.some(o =>
            o.AutorefreshRate || o.AutorefreshRate === undefined
        ) : true;
      
      if(Field === 'CurrencyID' && (objOrder?.BNOrderNo === null || objOrder?.BNOrderNo === undefined || objOrder?.BNOrderNo === 0 ) && customerType !== 'Supplier' && seconds !== '' && anyRefresh)
      {
        startTimer();
      }

      /*if(seconds !== '' && (Field === 'CostRate' || Field === 'Rate'))
      {
        const row = orderRows.find(r => r.key === key);
        if(row && row[Field] > 0 && row[Field] !== value)
        {
          setIsRunning(false);
          setSeconds('');
        }
      }*/

        setOrderRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], [Field]: value };
            }
            return rows;
        });
    }

    const onUpdateRowAmounts = (key, amount, rate, buyAmount, fee, denominations, profit, costRate, ratePrecision, rateTerms, averageRate) =>{

        setOrderRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], Amount: amount, Rate: rate, BuyAmount:buyAmount, Fee: fee, Denominations: [...denominations], Profit:profit, CostRate: costRate, RatePrecision: ratePrecision, RateTerms: rateTerms, AverageRate: averageRate, OriginalCustomerRate: rate, OriginalCostRate: costRate };
            }
            return rows;
        });
    }

  const onUpdateRowDenominations = (key, denominations) => {
    setOrderRows(prev => {
      const rows = [...prev];
      const index = rows.findIndex((r) => r.key === key);
      if (index > -1) {
        rows[index] = { ...rows[index], Denominations: [...denominations] };
      }
      return rows;
    });
  }

  const updateTotalOrderFee = useCallback((orderFee) =>{

    setOrderFee(orderFee);
  }, []);

  const updateTotalDeliveryFee = useCallback((deliveryFee) =>{
    setDeliveryFee(deliveryFee);
  }, []);

  const validHeader= ()=>{
     const prev = validationsHeader;
     const startDate = new Date();
     
     if(!allowOrderCurrentDate)
     {
      startDate.setDate(startDate.getDate() + 1);
     }

     const today = startDate.setHours(0,0,0,0);
     //const [h, m] = deliveryTime.split(':');
    const selectedDateTime = new Date(deliveryDate).setHours(0, 0,0,0);//.setHours(Number(h), Number(m),0,0);
    const showCompanyAddress = (lockedSide.toLowerCase() === 'buy' && deliveryMethod.toLowerCase().includes('sends currency'));
    const showCompanyAddressWithoutLocation = (lockedSide.toLowerCase() === 'sell' && deliveryMethod.toLowerCase().includes('at the vault'));
    const showVaultAdd = (lockedSide.toLowerCase() === 'buy' && deliveryMethod.toLowerCase().includes('armored'));
    const isDropOff = (lockedSide.toLowerCase() === 'buy' && deliveryMethod.toLowerCase().includes('drop-off'));
    const validations = {
        ...prev,
        DeliveryCustomerID : showCompanyAddressWithoutLocation || showVaultAdd || showCompanyAddress || isDropOff || deliveryCustomerID > 0,
        DeliveryDate: showCompanyAddress || selectedDateTime >= today,
        DeliveryTime: true,//showCompanyAddress || selectedDateTime >= today,
        DeliveryMethod: (deliveryMethod !== null && deliveryMethod !== undefined && deliveryMethod !== ''),
        BuyCurrency: (buyCurrency !== null && buyCurrency !== undefined && buyCurrency !== ''),
        CrossRate: (buyCurrency !== baseCurrency && crossRate > 0) || buyCurrency === baseCurrency,
        Instrument: (instrument !== null && instrument !== undefined && instrument !== ''),
        SettlementMethod: (settlementMethod !== null && settlementMethod !== undefined && settlementMethod !== ''),
        VaultID : !showVaultAdd || vaultID > 0,
      };

    setValidationsHeader(validations);

    return Object.values(validations).every(Boolean)
  }

  const onNextClick = () =>{    
    const orders = [...orderRows];
    if(orders.length > 0)
    {

    const orderRowsValidated = orderRows.map(o => ({
        ...o,
        validations: rowIsValid(o)
      }));
      setOrderRows(orderRowsValidated);

      const allValid = orderRowsValidated.every(o =>
        Object.values(o.validations).every(Boolean)
      );

      const headerIsValid = validHeader();
      setNewRow({CurrencyID:''});
        
      if(allValid && headerIsValid)
      {
        //let totalOrderFee = (objOrder.BNOrderNo > 0)?objOrder.OrderFee:0;
        //let totalDeliveryFee = (objOrder.BNOrderNo > 0) ? objOrder.DeliveryFee:0;

        /*
        if((objOrder.BNOrderNo === undefined || objOrder.BNOrderNo === null)||(objOrder.BNOrderNo > 0 && totalBuyAmount !== originalTotalOrder))
        {
          const responseTotalOrderFee = await getTotalOrderFee(customerID, totalBuyAmount, lockedSide);
          totalOrderFee = (responseTotalOrderFee.Success)?responseTotalOrderFee.TotalOrderFee:0;
        }

        if((objOrder.BNOrderNo === undefined || objOrder.BNOrderNo === null)||
            (objOrder.BNOrderNo > 0 && (totalBuyAmount !== originalTotalOrder || deliveryMethod !== originalDeliveryMethod)))
        {
          let deliveryFeeId = 0;
          const fee = deliveryMethodList.find(f => f.name === deliveryMethod)
          if(fee && fee.DeliveryFeeID > 0) { deliveryFeeId = fee.DeliveryFeeID; }
          const responseDeliveryFee = await getTotalDeliveryFee(customerID, totalBuyAmount, lockedSide, deliveryFeeId);
          totalDeliveryFee = (responseDeliveryFee.Success)?responseDeliveryFee.TotalDeliveryFee:deliveryFee;
        }
*/
        objOrder.DeliveryDate = /*new Date(nextBusinessDate)*/deliveryDate;
        objOrder.DeliveryTime = deliveryTime;
        objOrder.DeliveryCustomerID = deliveryCustomerID;
        objOrder.DeliveryText = deliveryText;
        objOrder.DeliveryContactName = deliveryContactName;
        objOrder.OrderRows = orderRowsValidated;
        objOrder.TotalOrder = totalBuyAmount;
        objOrder.TotalProfit = totalProfit;
        objOrder.DenominationFee = totalDenominationFees;
        objOrder.DeliveryFee = deliveryFee;//totalDeliveryFee;//deliveryFee;
        objOrder.OrderFee = orderFee;//totalOrderFee;
        objOrder.DeliveryMethod = deliveryMethod;
        objOrder.BuyCurrency = buyCurrency;
        objOrder.CrossRate = crossRate;
        objOrder.SettlementInstrument = instrument;
        objOrder.SettlementMethod = settlementMethod;
        objOrder.VaultID = vaultID;

        updateOrder(objOrder);


        changeScreen();
      }   
      else
      {
        const duplicateCcy = orderRowsValidated.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
        if(duplicateCcy)
            {              
              setDuplicateCcyMessage(`The Order has duplicate Currencies. Do you want to continue?`);       
              setNewRow({CurrencyID:'Valid'});
              setShowDuplicateCcyConfirmation(true);
            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
      }               
    }

  }

  const updateDeliveryTo = (value, label, fee, contactName) => {
    if (value > 0) {
      setDeliveryCustomerID(value);
      setDeliveryText(label);
      setDeliveryFee(fee);
      setDeliveryContactName(contactName);
    }
  }

  const updateVault = (value, label) =>{
    if(value)
    {
      if(value > 0)
      {
        setVaultID(value);
        setDeliveryText(label);
        setDeliveryCustomerID(0);
      }
      else
      {
        setVaultID(0);
      }
    }
  }

  const updateBuyCurrency = (currency, crossRate) =>{
    if(currency.value !== '')
    {
      setBuyCurrency(currency.value);
      setBuyScale(currency.NumberOfDecimals);
      setCrossRate(crossRate);
      updateBuyCurrencyValue(currency.value, crossRate);

      setBuyScaleCtx(currency.NumberOfDecimals);

    }
  }

   const updateField = (field, value) =>{
    switch(field){
      case 'Instrument': setInstrument(value); break;
      case 'SettlementMethod': setSettlementMethod(value); break;
      default: break
    }
  }

  const getHeaders = () =>{
     return(
            <tr>
                <th key="1">Currency</th>
                <th key="8">Condition</th>
                <th key="2" style={{textAlign:'right'}}>Amount</th>
                {showCostRate &&
                <th key="6" style={{textAlign:'right'}}> Market Rate</th>}
                <th key="3" style={{textAlign:'right'}}>Rate</th>
                
                <th key="88" style={{textAlign:'right'}}>Fee</th>
                <th key="4" style={{textAlign:'right'}}>{`${buyCurrency} Value`}</th>                

                {showCostRate &&
                <th key="7" style={{textAlign:'right'}}> Profit</th>}
                <th key="5">{((objOrder?.BNOrderNo === null || objOrder?.BNOrderNo === undefined || objOrder?.BNOrderNo === 0) && customerType !== 'Supplier' ) && <Progress type="circle" percent={progressTimeout} className="ant-progress-inner-order" format={() => `${formattedTimeOut}`} /> }</th>
            </tr>
        );
  }

  const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

  const openAlert = (title, message) => {
        setShowAlert(true);
        setAlertTitle(title);
        setAlertMessage(message);
    };


  const onTab = (e) => {

    if (e.key === 'Tab') {
      e.preventDefault();
      onAddClick();
    }
  }  

  const closeVoidConfirmation = () =>{
    setShowVoidConfirmation(false);
  }

  const yesVoidConfirmation = async() =>{
    setShowVoidConfirmation(false);
    setLoading(true);
    const userID=localStorage.getItem('UserID');
    const responseSave = await voidBNOrder(objOrder.BNOrderNo, objOrder.UpdateToken, userID);
    setLoading(false);    
    const message = [];
    message.push(responseSave.Message);    
    if(responseSave.Success)
    {
       if(backToSearchScreen)
       {
        backToSearchScreen();
       }
    }
  
    setAlertTitle(responseSave.Title);
    setAlertMessage(message);
    setShowAlert(true);
    
  }

  const onVoidClick = ()=>{
    setShowVoidConfirmation(true);
  }

     const getStatus = () =>{
          const status = [];
          if(objOrder.StatusProgress)
          {        
              const statusProgress = JSON.parse(objOrder.StatusProgress)
              if(statusProgress && statusProgress.length > 0)
              {
                  statusProgress.forEach(s =>
                      {
                          let icon = <CheckOutlined style={{color:s.color}}/> 
                          switch(s.icon)
                          {
                              case 'RocketTwoTone': icon = <RocketTwoTone twoToneColor={s.color}/>; break;
                              case 'TruckOutlined': icon = <FontAwesomeIcon icon={faTruck}  style={{color:s.color, fontSize:'16px'}}/>; break;
                              case 'BankOutlined': icon = <BankOutlined style={{color:s.color}}/>; break;
                              default: icon = <CheckOutlined style={{color:s.color}}/> 
                          }
                          status.push(<Step title={s.title} description={s.description} status={s.status} icon={icon}/> );                        
                      }
                  )
              }
          }
          return status;
      }
  
      const getSettlementStatus = () =>{
          if(objOrder.SettlementStatusProgress)
          {        
              const statusProgress = JSON.parse(objOrder.SettlementStatusProgress)
  
              const description = statusProgress.PendingAmount === 0 &&  statusProgress.DateSettlement !== '' ?  statusProgress.DateSettlement : `${formatToCurrencyWithScale(statusProgress.PendingAmount,buyScale)} ${objOrder.BuyCurrency}`;
  
              return <center style={{display:'grid'}}>
                      <DollarOutlined style={{color:statusProgress.Color ,fontSize:'32px'}}/>
                      <span>{statusProgress.SettlementStatus}</span>
                      <span>{description}</span>
              </center>
          }
      }

  //init timer

  useLayoutEffect(() => {
    orderRowsRef.current = orderRows;
}, [orderRows]);

  

 const onFinish = useCallback(async(currentRows, restartTimer) => {

    if (!currentRows || currentRows.length === 0) {
      return;
    }
    
    const anyRefresh = (orderRows && orderRows.length > 0) ? orderRows.some(o =>
            o.AutorefreshRate || o.AutorefreshRate === undefined
        ) : true;
        
    if(customerType !== 'Supplier' && anyRefresh)
    {
      
      const newRows = await getRateAllRows(
        currentRows,
        buyCurrency,
        customerID,
        deliveryDate,
        lockedSide,
        buyScale
      );

      newRows.forEach((row, index) => {

        const rateResponse = {
          BuyAmount: row.BuyAmount,
          RateTerms: row.RateTerms,
          Rate: row.Rate,
          CostRate: row.CostRate,
          RatePrecision: row.RatePrecision,
          Denominations: row.Denominations,
          Profit: row.Profit,
          AverageRate: row.AverageRate
        }

        rateStore.update(row.key, rateResponse);
      });
      setOrderRows(newRows);
    }
    else
    {
      stopTimer();
      setSeconds(INITIAL_TIME);
    }

    if(restartTimer && customerType !== 'Supplier' && anyRefresh){
      startTimer();
    }
  }, [buyCurrency, customerID, deliveryDate, lockedSide, buyScale ]);

  const intervalRef = useRef(null)

  useEffect(() => {

    if (!isRunning) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      return;
    };

    intervalRef.current = setInterval(() => {

      setSeconds(prev => {

        if (prev <= 1) {

          onFinish(orderRowsRef.current, true);
          return INITIAL_TIME;
        }

        return prev - 1;
      });

    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };

  }, [isRunning, buyCurrency, deliveryDate, lockedSide, buyScale]);

  /*useEffect(() => {
    if (timerIsRunning) {
      setIsRunning(true)
    }
  }, [timerIsRunning]);*/

    useEffect(() => {

      if (!refreshRates) return;
      if (!orderRowsRef.current || orderRowsRef.current.length === 0) {
        return;
      }

      if(orderRowsRef.current.length > 0 && orderRowsRef.current[0].CurrencyID === '' ){
        return;
      }
      onFinish(orderRowsRef.current,true);

      resetRefreshRates();

    }, [refreshRates,orderRowsRef.current]);

  const startTimer = () => {
    if(!isRunning)
    {
      setSeconds(INITIAL_TIME);
      setIsRunning(true);
    }
  };

  const stopTimer = useCallback(() => {
  
          if (intervalRef.current) {
              clearInterval(intervalRef.current);
              intervalRef.current = null;
          }
  
          setIsRunning(false);  
      }, []);

  const formattedTimeOut = useMemo(() => {
    
      const minutesTime = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;

      return `${String(minutesTime).padStart(2, "0")}:${String(
        remainingSeconds
      ).padStart(2, "0")}`;
    
  }, [seconds]);

  const progressTimeout = (seconds / INITIAL_TIME) * 100;
// end timer

  const onRefreshRatesClick = () =>{
    onFinish(orderRows, false);
  }

  const closeDuplicateCcyConfirmation = () =>{
    setNewRow({CurrencyID:''});
    setShowDuplicateCcyConfirmation(false);
  }  

  const yesDuplicateCcyConfirmation = () =>{
    if(newRow && newRow.CurrencyID !== '' && newRow.CurrencyID !== 'Valid')
    {
     const orders = [...orderRows];
     orders.push(newRow);
     setOrderRows(orders);
    }
    else
    {
       onNextClick()
    }
     setShowDuplicateCcyConfirmation(false);
  }  

  const onNewOrderClick = () =>{
    if (window.isOrderChanged) {
            setShowNewOrderConfirmation(true);
        } else {
            newOrder(customerID, contactID, customerName);
        }
  }

  const closeNewOrderConfirmation = () =>{
    setShowNewOrderConfirmation(false);
  }

  const  yesNewOrderConfirmation = () =>{
    setShowNewOrderConfirmation(false);
    newOrder(customerID, contactID, customerName);
  }
 
  const OrderSpreadModal = React.memo(() => {
    return <OrderSpreadModalForm />
  });

  const updateSpreadModalForm = (key) => {
    setOrderRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], AutorefreshRate: false, SpreadUpdatedByUser: true };
            }
            return rows;
        });
  }

 return (
    <div>

        <div>
           {objOrder && objOrder.BNOrderNo > 0 && 
              <div id={'ordersummary11'} key ={'ordersummary11'} className="uk-grid" style={{alignContent: 'center'}}>
                  <div className="uk-width-1-12" >
                  </div>
                      <div className="uk-width-8-12" style={{paddingLeft:'0px',alignContent: 'center'}}>
                              <Steps className="step-order">
                                  {getStatus()}
                              </Steps>
                      </div>
                      <div className="uk-width-2-12" style={{paddingLeft:'0px'}}>
                           {getSettlementStatus()}
                      </div>
                    
                  </div>}

                <OrderInformationHeader customerName={customerName} customerID={customerID} validations={validationsHeader} locationCustomerID={deliveryCustomerID} date={deliveryDate} time={deliveryTime} updateDeliveryDate={(date) => setDeliveryDate(date)}
                  updateDeliveryTime={(time) => setDeliveryTime(time)} updateDeliveryTo={updateDeliveryTo}
                  lockedSide={lockedSide} deliveryMethodList={deliveryMethodList} updateDeliveryMethod={(d) => {setDeliveryMethod(d.value)}}
                  deliveryMethodSelected={deliveryMethod} settlementCurrenciesList={settlementCurrenciesList} defaultSettlementCurrency={defaultSettlementCurrency} 
                  updateBuyCurrency={updateBuyCurrency} buyCurrencySelected={buyCurrency} crossR={crossRate} totalOrder={totalBuyAmount}
                   instruments={instruments} settlementMethods={settlementMethods} updateField={updateField} defaultInstrument={defaultInstrument} defaultSettlementMethod={defaultSettlementMethod}
                   selectedtInstrument={instrument} selectedSettlementMethod={settlementMethod} allowOrderCurrentDate={allowOrderCurrentDate}
                   vaults={vaults} selectedVaultID={vaultID} updateVault={updateVault} customerDefaultDeliveryMethod={customerDefaultDeliveryMethod}/>
        
            <table className="uk-table uk-table-hover uk-table-divider border-table">
                <thead>
                        {getHeaders()}
                </thead>
                <tbody>
                        {getRows()}
                </tbody>
            </table>
        
        </div>
        <div  align="right">
            <button id={'btn-order-add'} onKeyDown={onTab} key={'btn-order-add'} className="uk-button uk-button-green" onClick={onAddClick}>
                {'Add'}
            </button>
        </div>
        <Divider />
        <OrderInformationFooter buyScale={buyScale} updateTotalOrderFee={updateTotalOrderFee} updateTotalDeliveryFee={updateTotalDeliveryFee} orderFeeC={orderFee} denFeeC={totalDenominationFees}
           deliveryFeeC={deliveryFee} totalOrderC={totalBuyAmount}
           lockedSide={lockedSide} />
        <Divider />
        <div  align="right">
            {objOrder.BNOrderNo > 0 &&
            <button className="uk-button uk-button-green" onClick={onVoidClick}>
                {'Void'}
            </button>}
            {objOrder.BNOrderNo > 0 && customerType !== 'Supplier' &&
            <button className="uk-button uk-button-green" onClick={onRefreshRatesClick}>
                {'Refresh Rates'}
            </button>}
            <button className="uk-button uk-button-green" onClick={onNewOrderClick}>
                {'New Order'}
            </button>
            <button className="uk-button uk-button-green" onClick={onNextClick}>
                {'Next'}
            </button>
        </div>
        <LoadingBox loading={loading}/>
        <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        <AlertBox id="void-confirmation"
                            open={showVoidConfirmation}
                            title="Confirmation"
                            message="Are you sure you want to void this order?"
                            type="Yes/No"
                            onClose={closeVoidConfirmation}
                            yesClick={yesVoidConfirmation}
                            noClick={closeVoidConfirmation}/>
        <AlertBox id="void-confirmation-ccy"
                            open={showDuplicateCcyConfirmation}
                            title="Warning"
                            message={duplicateCcyMessage}
                            type="Yes/No"
                            onClose={closeDuplicateCcyConfirmation}
                            yesClick={yesDuplicateCcyConfirmation}
                            noClick={closeDuplicateCcyConfirmation}/>
        <AlertBox id="new-order-confirmation"
                            open={showNewOrderConfirmation}
                            title="Warning"
                            message={'You have unsaved changes. Your changes will be lost.'}
                            type="Yes/No"
                            onClose={closeNewOrderConfirmation}
                            yesClick={yesNewOrderConfirmation}
                            noClick={closeNewOrderConfirmation}/>
     
     <OrderSpreadModalForm updateSpreadModalForm={updateSpreadModalForm}/>
    </div>
  );
};

export default OrderInformationScreen